import { getPlatformUrlParts } from '@acl-services/highbond-common';
import { muiLicense } from '@diligentcorp/atlas-mui-license';
import * as ReactDOM from 'react-dom/client';
import App from './app';
import './i18n';
import './utils/supressWarnings';

const PENDO_CLIENT_KEY = 'de9611a5-61a3-4d0e-715e-c618cdcb4269';

muiLicense.apply();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// The Pendo CNAME is only configured for content.pendo.highbond.com
// (no environment suffix), shared across all environments.
// TODO: Once diligentoneplatform is added to Pendo,
// replace the hardcoded domain with the domain from the URL:
// Reference: https://diligentbrands.atlassian.net/wiki/spaces/DPM/pages/3513583110/Pendo+Basic+Installation+Process
// Reference: https://app.pendo.io/s/5738959954247680/admin/app/-323232?tab=install
// function getPendoContentHost(): string {
//   const { domain, tld } = getPlatformUrlParts(window.location.origin);
//   return `content.pendo.${domain}.${tld}`;
// }
function getPendoContentHost(): string {
  const { tld } = getPlatformUrlParts(window.location.origin);
  return `content.pendo.highbond.${tld}`;
}

const PENDO_METHODS = [
  'initialize',
  'identify',
  'updateOptions',
  'pageLoad',
  'track',
] as const;

function setupPendoQueue(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const win = window as any;
  win['pendo'] = win['pendo'] || {};
  const { pendo } = win;

  // eslint-disable-next-line no-underscore-dangle
  pendo._q = pendo._q || [];

  for (const method of PENDO_METHODS) {
    if (!pendo[method]) {
      pendo[method] = (...args: unknown[]) => {
        // eslint-disable-next-line no-underscore-dangle
        const action = method === 'initialize' ? 'unshift' : 'push';
        pendo._q[action]([method, ...args]);
      };
    }
  }
}

function loadPendoAgent(): void {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://${getPendoContentHost()}/agent/static/${PENDO_CLIENT_KEY}/pendo.js`;
  document.head.appendChild(script);
}

function includePendo(): void {
  setupPendoQueue();
  loadPendoAgent();
}

includePendo();

root.render(<App />);
